/// <reference types="crypto-js" />

import {Injectable} from '@angular/core';
import {PRODUCTION_BUILD, SYSTEM_NAME} from '../app.settings';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';

import * as CryptoJS from 'crypto-js';
import { StringUtils } from '../utils/string-utils';
import { Session } from '../models/session.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class AppCommunicationService {
    // Admin roles
    public static USER_ROLE_SUPERADMIN = 600;
    public static USER_ROLE_UK_ADMIN = 500;

    // Basic roles
    public static USER_ROLE_ANONYMOUS = 0;
    public static POSSIBLE_ROLES: string[] = [ 'SUPERADMIN','UK_ADMIN'];
    public static POSSIBLE_BASIC_ROLES: string[] = [];

    loadingAnimation: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    loadingAnimationText: Subject<string> = new Subject<string>();
    static decryptData(data) {
        return data;
    }

    static getCurrentUser(): Session {
        return AuthenticationService.getCurrentUser();
    }

    constructor() {
    }

    loadingOn(text = null) {
        if (text) {
            this.loadingAnimationText.next(text);
        }
        this.loadingAnimation.next(true);
    }

    loadingOff() {
        this.loadingAnimation.next(false);
        this.loadingAnimationText.next(null);
    }


    getRoleOfLoggedUser(): number {
        const roles = this.getCurrentUserRoles();

        if (roles.includes('SUPERADMIN')) {
            return AppCommunicationService.USER_ROLE_SUPERADMIN;
        }
        if (roles.includes('UK_ADMIN')) {
            return AppCommunicationService.USER_ROLE_UK_ADMIN;
        }
        return AppCommunicationService.USER_ROLE_ANONYMOUS;
    }

    isUserLogged(): boolean {
        return this.getRoleOfLoggedUser() > AppCommunicationService.USER_ROLE_ANONYMOUS;
    }

    isUserAdmin(): boolean {
        return this.getRoleOfLoggedUser() >= 100;
    }

    getCurrentUserRoles(): string[] {        
        const userRoles: string[] = [];
        const currentUser = AppCommunicationService.getCurrentUser();

        if (!currentUser) {
            return userRoles;
        }

        currentUser.user.roles.forEach(role => {
            if (AppCommunicationService.POSSIBLE_ROLES.includes(role)) {
                userRoles.push(role);
            }
        });
        return userRoles;
    }

    hasUserRole(role: string): boolean {
        const roles = this.getCurrentUserRoles();
        return roles.includes(role);

    }

    getUserBasicRoles():string[] {
        const subroles:string[] = [];
        
        const roles = this.getCurrentUserRoles();
        roles.forEach(role => {
            if (AppCommunicationService.POSSIBLE_BASIC_ROLES.includes(role)) {
                subroles.push(role);        
            }                                          
        });

        return subroles;
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/app-communication.service.ts